import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'WASH_ORDER_DETAIL',
        create: 'WASH_ORDER_CREATE',
        update: 'WASH_ORDER_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'remark',
        default: '',
        label: '备注',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};